import request from '@/utils/request'

// 获取用户列表
export function listUsers(params) {
  return request({
    url: '/api/admin/users',
    method: 'get',
    params
  })
}

// 获取用户详情
export function getUser(userId) {
  return request({
    url: `/api/admin/users/${userId}`,
    method: 'get'
  })
}
